export default "__VITE_ASSET__CzW57pOo__"